export enum JoinRequestStatusFilter {
  ALL = 'all',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export const joinRequestStatusFilterMap: Record<
  JoinRequestStatusFilter,
  boolean | undefined | null
> = {
  [JoinRequestStatusFilter.ALL]: undefined,
  [JoinRequestStatusFilter.PENDING]: null,
  [JoinRequestStatusFilter.ACCEPTED]: true,
  [JoinRequestStatusFilter.REJECTED]: false,
}
